<fe-header style="z-index: 10000"></fe-header>
<main>
    <section class="city__airport__top position-relative d-flex">
        <img
            class="container-fluid px-0 d-none d-sm-flex"
            [src]="cityDetails?.data?.city?.imgHorizontal"
            *ngIf="isImageLoadedHorizontal"
            alt="Alamo City Horizontal"
        />
        <img
            class="container-fluid px-0 d-flex d-sm-none"
            [src]="cityDetails?.data?.city?.imgVertical"
            *ngIf="isImageLoadedVertical"
            alt="Alamo City Vertical"
        />
    </section>
    <section
        class="city__airport__middle py-2 d-flex align-items-center justify-content-center"
    >
        <h1 class="city__airport__middle__text my-0">
            {{ 'fe_destinations_airport_city_title' | translate }}
            {{ cityDetails?.data?.city?.name }}
        </h1>
    </section>
    <section class="city__airport__search py-2">
        <div class="container py-4 px-1 px-lg-8">
            <fe-search-reservation
                [container]="'container-fluid'"
                [isNormal]="true"
            ></fe-search-reservation>
        </div>
    </section>
    <fe-location-detail-destination
        (locationDetailsLoaded)="onLocationDetailsLoaded($event)"
    ></fe-location-detail-destination>
    <section
        class="city__airport__bottom py-2 d-flex align-items-center justify-content-center"
    >
        <div class="container py-4 px-0 px-md-2 px-lg-8">
            <h5 [innerHTML]="cityDetails?.data?.city?.name"></h5>
            <p
                class="city__airport__bottom__text m-0"
                [innerHTML]="cityDetails?.data?.city?.description"
            ></p>
            <p
                class="city__airport__bottom__text m-0"
                [innerHTML]="cityDetails?.data?.city?.descriptionExtra"
            ></p>
        </div>
    </section>
    <fe-show-city-office-details ngSkipHydration></fe-show-city-office-details>
</main>
<fe-footer></fe-footer>
